import React, { useState, useEffect } from "react";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

const ColorTheme = () => {
  const { getText } = useLanguageTranslation();
  const [, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check localStorage for the user's preferred theme
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme === "dark") {
      document.body.classList.add("black-theme");
      setIsDarkMode(true);
    } else if (savedTheme === "light") {
      document.body.classList.remove("black-theme");
      setIsDarkMode(false);
    } else {
      // If no preference is saved, apply the system theme
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)");
      if (systemTheme.matches) {
        document.body.classList.add("black-theme");
        setIsDarkMode(true);
      } else {
        document.body.classList.remove("black-theme");
        setIsDarkMode(false);
      }

      // Watch for system theme changes
      systemTheme.addEventListener("change", (e) => {
        if (e.matches) {
          document.body.classList.add("black-theme");
          setIsDarkMode(true);
        } else {
          document.body.classList.remove("black-theme");
          setIsDarkMode(false);
        }
      });

      return () => {
        systemTheme.removeEventListener("change", () => {});
      };
    }
  }, []);

  // Check system theme preference and apply dark/light mode
  // useEffect(() => {
  //   const systemTheme = window.matchMedia("(prefers-color-scheme: dark)");

  //   // Set dark mode based on system preference
  //   if (systemTheme.matches) {
  //     document.body.classList.add("black-theme");
  //     setIsDarkMode(true);
  //   } else {
  //     document.body.classList.remove("black-theme");
  //     setIsDarkMode(false);
  //   }

  //   // Add event listener to watch for system theme changes
  //   systemTheme.addEventListener("change", (e) => {
  //     if (e.matches) {
  //       document.body.classList.add("black-theme");
  //       setIsDarkMode(true);
  //     } else {
  //       document.body.classList.remove("black-theme");
  //       setIsDarkMode(false);
  //     }
  //   });

  //   // Clean up the event listener
  //   return () => {
  //     systemTheme.removeEventListener("change", () => {});
  //   };
  // }, []);

  // Manually toggle themes
  const blackTheme = () => {
    document.body.classList.add("black-theme");
    setIsDarkMode(true);
    localStorage.setItem("theme", "dark");
  };

  const normalTheme = () => {
    document.body.classList.remove("black-theme");
    setIsDarkMode(false);
    localStorage.setItem("theme", "light");
  };

  return (
    <>
      <li className="text-size">
        <a
          href={"#"}
          title={getText("White Theme", "")}
          className="whitebg"
          onClick={(e) => {
            e.preventDefault();
            normalTheme();
          }}
        ></a>
        <a
          href={"#"}
          title={getText("Black Theme", "")}
          className="blackbg"
          onClick={(e) => {
            e.preventDefault();
            blackTheme();
          }}
        ></a>
      </li>

      <li>
        <a
          href={`${process.env.REACT_APP_LOGIN_URL}/user/login`}
          target="_blank" rel="noopener noreferrer"
          className="hide skiptomain"
          title={getText("Login", "लॉगिन")}
        >
          {getText("Login", "लॉगिन")}
        </a>
      </li>
    </>
  );
};

export default ColorTheme;
